const EditIcon = ({ width, height, style, onClick }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      <path
        d="M14.5742 2.70054L12.2995 0.42581C12.0249 0.151208 11.6598 0 11.2715 0C10.8832 0 10.5182 0.151208 10.2436 0.425801L0.721493 9.94786C0.631112 10.0382 0.572851 10.1558 0.555677 10.2824L0.00531097 14.3371C-0.0192209 14.5179 0.0421088 14.6998 0.171153 14.8289C0.281458 14.9392 0.430383 15 0.584268 15C0.610374 15 0.636648 14.9983 0.662896 14.9947L4.71753 14.4443C4.84421 14.4271 4.96175 14.3689 5.05213 14.2785L14.5742 4.75647C14.8488 4.4819 15 4.11682 15 3.72852C15 3.34019 14.8488 2.97512 14.5742 2.70054ZM4.36513 13.3128L1.26654 13.7334L1.68713 10.6348L8.43475 3.88726L11.1127 6.56527L4.36513 13.3128ZM13.7479 3.93013L11.9391 5.73894L9.26107 3.06094L11.0699 1.25214C11.1426 1.17946 11.2274 1.1686 11.2715 1.1686C11.3156 1.1686 11.4005 1.17946 11.4732 1.25214L13.7479 3.52687C13.8206 3.59954 13.8314 3.68439 13.8314 3.72849C13.8314 3.7726 13.8206 3.85745 13.7479 3.93013Z"
        fill="#939393"
      />
    </svg>
  );
};

export default EditIcon;
